(function(angular){
	'use strict';
	
	angular.module('videoModule', [
		'BaseConfig',
		'revealModule'
	]);

})(window.angular);